import React from "react";

const Separator = ({ mainClass, textClass, text, margin, dataTestid }) => {
  const noText = !(text !== undefined);
  return (
    <div style={{ margin: margin ?? "" }} className={`${mainClass ? mainClass : "separator"}`}>
      <span
        data-testid={dataTestid}
        className={`${textClass ? textClass : noText ? "separator__noText" : "separator__text"}`}
      >
        {text}
      </span>
    </div>
  );
};

export default Separator;
